import React from 'react'
import PropTypes from 'prop-types'
/* --------------------------------------------- */
const EditPencilIcon = ({ color, ...rest }) => (
    
    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 30 30" {...rest}>
    <path fill={color} fill-rule="evenodd" d="M16.326 15l13.4-13.4c.366-.366.366-.959 0-1.325-.367-.367-.96-.367-1.326 0L15 13.675 1.6.274C1.234-.092.641-.092.275.275c-.367.366-.367.959 0 1.325l13.4 13.4-13.4 13.4c-.367.366-.367.959 0 1.325.183.183.423.275.663.275.24 0 .48-.092.662-.275l13.4-13.4 13.4 13.4c.183.183.423.275.663.275.24 0 .48-.092.662-.275.367-.366.367-.959 0-1.325L16.325 15z"/>
</svg>



)
/* --------------------------------------------- */
EditPencilIcon.propTypes = {
    /** Color of icon. */
    color: PropTypes.string,
    /** Icon css styles. */
    style: PropTypes.object
}
/* --------------------------------------------- */
EditPencilIcon.defaultProps = {
    color: 'transparent',
    
}
/* --------------------------------------------- */
export default EditPencilIcon
/* --------------------------------------------- */
